import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { frenchDate } from "@/lib/shariti";
import { RotateCw } from "lucide-react";

// Repère de rotation « en amont » (avant booking). Réutilisable partout où un CDP
// consulte des emplacements : panneau Spots disponibles, recherche d'historique,
// assistant d'appel, etc. Reflète le DERNIER passage + la PROCHAINE disponibilité
// (toutes associations confondues). Ne rien afficher si le statut est inconnu.
const STYLES = {
  block: {
    pill: "border-[rgba(214,69,69,0.4)] bg-[rgba(214,69,69,0.08)] text-[#9B2226]",
    dot: "bg-[#D64545]",
    label: "En rotation",
    title: "En rotation — un booking maintenant serait un rebooking forcé",
  },
  warn: {
    pill: "border-[rgba(240,190,20,0.6)] bg-[rgba(252,219,83,0.28)] text-[#8A6D00]",
    dot: "bg-[#E0A400]",
    label: "Bientôt libre",
    title: "Exploité récemment — une autre association peut venir, la même reste bloquée",
  },
  ok: {
    pill: "border-[rgba(31,157,85,0.35)] bg-[rgba(31,157,85,0.08)] text-[#1F7A44]",
    dot: "bg-[#1F9D55]",
    label: "Libre",
    title: "Aucune contrainte de rotation",
  },
};

export const RotationMarker = ({ status, compact = false, className = "" }) => {
  if (!status || !status.level || !STYLES[status.level]) return null;
  const s = STYLES[status.level];
  const last = status.last_passage;
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            data-testid={`rotation-marker-${status.level}`}
            className={`inline-flex shrink-0 items-center gap-1 rounded-full border px-1.5 py-0.5 text-[10px] font-bold leading-none ${s.pill} ${className}`}>
            <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} aria-hidden />
            {!compact && <span>{s.label}</span>}
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-[240px] space-y-1 bg-[var(--shariti-ink)] text-white">
          <div className="flex items-center gap-1.5 text-[11px] font-bold">
            <RotateCw className="h-3 w-3" /> {s.title}
          </div>
          {last ? (
            <div className="text-[11px]">
              Dernier passage : <span className="font-semibold">{last.association_acronym}</span>
              {last.date ? ` · ${frenchDate(String(last.date).slice(0, 10))}` : ""}
            </div>
          ) : (
            <div className="text-[11px]">Aucun passage récent enregistré.</div>
          )}
          {status.next_available && status.level !== "ok" && (
            <div className="text-[11px]">
              Réservable (toutes assos) dès : <span className="font-semibold">{frenchDate(String(status.next_available).slice(0, 10))}</span>
            </div>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default RotationMarker;
